import { PlanType } from "@brookbush/database";

import { useStripeSubscription } from "~/hooks";
import usePlanConfig from "~/hooks/usePlanConfig";

const BecomeAMemberExistingCaution = () => {
	const { isActive, planType } = useStripeSubscription();

	const { planConfig } = usePlanConfig();

	if (!isActive || planType === planConfig.planType) return null;

	return (
		<div className="rounded-xl bg-red-50 px-3 py-1.5 text-sm dark:bg-red-300/20">
			<strong>Membership Notice: </strong>
			{planType === PlanType.INDIVIDUAL ? (
				<span>
					Your existing individual membership will be cancelled and you will be
					refunded the prorated amount on your personal payment method upon
					activating the team membership.{" "}
				</span>
			) : (
				<span>
					Your existing team membership will be cancelled (Everyone in your team
					will lose access) and you will be refunded the prorated amount on your
					team payment method upon activating the individual membership.
				</span>
			)}
		</div>
	);
};

export default BecomeAMemberExistingCaution;
